import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { 
  FiPieChart, FiZap, FiFilter, FiUsers, 
  FiShield, FiLayers, FiActivity, FiHistory, 
  FiMail, FiSettings 
} = FiIcons;

const Sidebar = ({ activeTab, setActiveTab }) => {
  const menuItems = [
    { id: 'overview', label: 'Dashboard', icon: FiPieChart, category: 'Main' },
    { id: 'events', label: 'Events', icon: FiZap, category: 'Analytics' },
    { id: 'funnels', label: 'Funnels', icon: FiFilter, category: 'Analytics' },
    { id: 'users', label: 'Identities', icon: FiUsers, category: 'Management' },
    { id: 'resolution', label: 'Governance', icon: FiShield, category: 'Management' },
    { id: 'groups', label: 'Groups', icon: FiLayers, category: 'Management' },
    { id: 'health', label: 'System Health', icon: FiActivity, category: 'Infrastructure' },
    { id: 'audit', label: 'Audit Log', icon: FiHistory, category: 'Infrastructure' },
    { id: 'reports', label: 'Reports', icon: FiMail, category: 'Infrastructure' },
  ];

  const categories = [...new Set(menuItems.map(item => item.category))];

  return (
    <div className="w-64 h-screen fixed left-0 top-0 bg-white border-r border-slate-200 flex flex-col z-40">
      <div className="p-6 flex items-center gap-3">
        <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center text-white shadow-md">
          <SafeIcon icon={FiZap} />
        </div>
        <h1 className="text-lg font-bold text-slate-900 tracking-tight">Intuitus</h1>
      </div>

      <nav className="flex-1 overflow-y-auto px-4 py-4 space-y-6">
        {categories.map(category => (
          <div key={category}>
            <h3 className="px-3 mb-2 text-[10px] font-semibold text-slate-400 uppercase tracking-wider">
              {category}
            </h3>
            <div className="space-y-1">
              {menuItems.filter(i => i.category === category).map(item => (
                <button
                  key={item.id}
                  onClick={() => setActiveTab(item.id)}
                  className={`w-full flex items-center gap-3 px-3 py-2 rounded-md transition-all text-sm font-medium ${
                    activeTab === item.id 
                      ? 'bg-blue-50 text-blue-600' 
                      : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
                  }`}
                >
                  <SafeIcon icon={item.icon} className="text-lg" />
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        ))}
      </nav>

      <div className="p-4 border-t border-slate-100">
        <button 
          onClick={() => setActiveTab('settings')}
          className={`w-full flex items-center gap-3 px-3 py-2 rounded-md transition-all text-sm font-medium ${
            activeTab === 'settings' 
              ? 'bg-blue-50 text-blue-600' 
              : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
          }`}
        >
          <SafeIcon icon={FiSettings} className="text-lg" />
          Settings & Tracking
        </button>
      </div>
    </div>
  );
};

export default Sidebar;